import { Injectable } from '@angular/core';
import {GoogleMapLoaderService} from './google/google-map-loader.service';
import {SclUtilMapService} from './scl-util-map.service';
import { AddressDetails } from './AddressDetails';

const sclUtilMapService = new SclUtilMapService();
const googleMapLoaderService = new GoogleMapLoaderService();


@Injectable({
  providedIn: 'root'
})
export class SclMapGeoGoogleService {
  constructor() { }

  autocompleteUrl = 'https://maps.googleapis.com/maps/api/geocode/json?address=';
  geocodeUrl = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=';
  googleLoader = null;
  initObj;


  autocompleteBox;
  autocompleteStreet;
  waitTime = 5000; // miliseconds
  apiKey;
  apiKeyReverse;
  country;
  language;
  loadLookup = false;
  cbSelectOption;
  intervalSetupLookUp;
  intervalSetupLookUpCount = 0;
  geocoderBoundary;

  
  reverse( coor, cb, cbErr, cbTimeout) {
    const lng = coor[0];
    const lat = coor[1];

    this.reverseGeocodeWithTimeout(lat, lng, this.waitTime)
    .then((result: any) => {
      console.log("***** address:", result);
      let streetData = new AddressDetails();
      streetData = sclUtilMapService.fillGoogleAddress(result, streetData);
      if (cb && typeof cb === 'function') {
        cb(streetData, {lat: result.geometry.location.lat, lng: result.geometry.location.lng});
      }
    })
    .catch(err => {
      if (err.status === -1) {
        console.error("Error timeout:", err.message);
        if (cbTimeout && typeof cbTimeout === 'function') {
          cbTimeout();
        }

      } else {
        console.error("Error:", err.status, err.message);
        if (cbErr && typeof cbErr === 'function') {
          cbErr('Google reverse Error');
        }
      }
    });
  }
  reverseGeocodeWithTimeout(lat, lng, timeoutMs = 5000) {
    return Promise.race([
      new Promise((resolve, reject) => {
        const geocoder = new google.maps.Geocoder();

        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === "OK" && results[0]) {
            resolve(results[0]);
          } else {
            const error = new Error(`Google reverse failed: ${status}`);
            (error as any).status = status;
            reject(error);
          }
        });

        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === "OK" && results[0]) {
            resolve({ address: results[0].formatted_address, status });
          } else {
            reject({ status, message: `Google reverse failed: ${status}` });
          }
        });
      }),
      new Promise((_, reject) => {
        setTimeout(() => reject({ status: -1, message: "Google reverse timeout exceeded" }), timeoutMs);
      })
    ]);
  }

  setupLookUp() {
    googleMapLoaderService.KEY = this.apiKey;
    googleMapLoaderService.LIBRARIES = 'places,drawing,visualization';
    googleMapLoaderService.SENSOR = true;
    if (this.intervalSetupLookUp) {
      return;
    }
    this.intervalSetupLookUp = setInterval(() => {
      this.autocompleteStreet = document.getElementById(this.initObj.keyName + 'autocomplete');
      if (this.autocompleteStreet) {
        clearInterval(this.intervalSetupLookUp);
        this.intervalSetupLookUp = null;
        this.intervalSetupLookUpCount = 0; // reset
        // console.log('find autocompletebox');
        googleMapLoaderService.load((google: any) => {
          // console.log(`**** load google library done, google = ${google}`);
          if (google) {
            const options: any = {
              types: ['geocode']
            };
            if (this.country) { 
              options.componentRestrictions = {
                country: this.country
              }
            }
            if (this.geocoderBoundary) {
              const bounds = this.getBoundsFromBoundary(this.geocoderBoundary);
              options.bounds = bounds;
              options.strictBounds = true;
            }


            const autocompleteObj = new google.maps.places.Autocomplete(this.autocompleteStreet, options);
  
            google.maps.event.addListener(autocompleteObj, 'place_changed', () => {
              const place = autocompleteObj.getPlace();
              let streetData = new AddressDetails();
              streetData = sclUtilMapService.fillGoogleAddress(place, streetData);
              if (this.cbSelectOption && typeof this.cbSelectOption === 'function' ) {
                this.cbSelectOption(streetData);
              }
  
            });
          }
          
        }, (err) => {
          console.log(`**** LOAD GOOGLE MAP ERROR:`, err);
        });
      } else {
        this.intervalSetupLookUpCount++;
        if (this.intervalSetupLookUpCount > 11) {
          console.log('can\'t load google geo service because can\'t find autocomplete box');
          clearInterval(this.intervalSetupLookUp);
          this.intervalSetupLookUp = null;
          this.intervalSetupLookUpCount = 0; // reset
        } else {
          console.log('waiting for autocomplete box loading..');
        }
      }
    }, 100);
  }

  lookUp( params, cb, cbErr, cbSelectOption, cbRemoveStreet, cbTimeout ) {
    if (params == null || params.length < 1) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('params invalid. [0] : autocompleteBox');
      }
      return;
    }
    if ( this.apiKey == null ) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('Google address lookup: apiKey is null');
      }
      return;
    }

    if (this.googleLoader === null) {
      this.autocompleteBox = params[0];

      if (!this.loadLookup) {
        this.loadLookup = true;
        this.cbSelectOption = cbSelectOption;
        this.setupLookUp();
      }
    }
  }

  removeLookUp() {
    const id = this.initObj.keyName + 'MapGeoGoogle';
    const lst = document.querySelectorAll('#' + id);
    if (lst && lst.length > 0) {
      for (let i = 0; i < lst.length; i++) {
        lst[i].remove();
      }
    }

    this.autocompleteBox = null;
    this.googleLoader = null;
  }

  removeStreet(cb) {
    if (this.autocompleteStreet == null) {
      this.autocompleteStreet = document.getElementById(this.initObj.keyName + 'autocomplete');
    }
    if (this.autocompleteStreet == null) {
      if (cb && typeof cb === 'function') {
        cb();
      }
      return;
    }
    this.autocompleteStreet.value = '';

    if (cb && typeof cb === 'function') {
      cb();
    }
  }

  getLinkOptions( link) {
    if (this.country) { link += '&region=' + this.country; }
    if (this.language) { link += '&language=' + this.language; }

    return link;
  }

  getBoundsFromBoundary(boundary: [number, number][]) {
    let north = -Infinity;
    let south = Infinity;
    let east = -Infinity;
    let west = Infinity;

    for (const [lat, lng] of boundary) {
      if (lat > north) north = lat;
      if (lat < south) south = lat;
      if (lng > east) east = lng;
      if (lng < west) west = lng;
    }

    return { north, south, east, west };
  }

}
